import React from 'react';

import { DataSheet } from 'src/components/ProductDetail/utils/product-detail.types';

import { Svg } from '../Svg/Svg';

import classes from './DataSheets.scss';

type DataSheetsProps = {
    dataSheets: DataSheet[];
};

export function DataSheets(props: DataSheetsProps) {
    return (
        <ul className={classes.datasheets}>
            {props.dataSheets.map((datasheet) => (
                <li key={datasheet.url + datasheet.filename + datasheet.attribute_code}>
                    <a href={datasheet.url} target="_blank" rel="noreferrer">
                        <span>{datasheet.filename}</span>
                        <Svg name="uparrowlink" />
                    </a>
                </li>
            ))}
        </ul>
    );
}
